import React, { useState, useEffect, useContext } from "react";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { AppContext } from "../../../../context/Context";

const ColumnsChart = ({ firstColor, secondColor, height, datas }) => {
  const [data, setData] = useState([]);
  const [active, setActive] = useState();

  const { dataRange, clearState } = useContext(AppContext);

  useEffect(() => {
    if (dataRange === "All") {
      if (clearState === "") {
        setActive(true);
        // console.log("testtrue");
      } else if (clearState === null) {
        // console.log("run else if");

        setTimeout(() => {
          setActive(true);
        }, 950);
      } else {
        setActive(false);
        // console.log("testtrue");
      }
    } else {
      if (clearState !== "") {
        setTimeout(() => {
          setActive(true);
        }, 950);
      }
    }
  }, [setActive, dataRange, clearState]);

  useEffect(() => {
    setData(datas);
  }, [datas]);

  // Format K / M for YAxis and LabelList
  const formatShort = (value) => {
    if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(2)}M`;
    if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
    return `$${value}`;
  };

  // Format full USD detail for tooltip
  const formatUSD = (value) =>
    `$${value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ left: 30, top: 20 }}>
        <defs>
          <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={firstColor} />
            <stop offset="100%" stopColor={secondColor} />
          </linearGradient>
        </defs>

        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="month" />
        <YAxis
          tickFormatter={formatShort}
          domain={[0, "dataMax + 5000"]}
          style={{ marginLeft: 100 }}
        />
        <Tooltip
          formatter={(value) => [formatUSD(value), "Total"]}
          cursor={false}
        />
        <Bar
          dataKey="revenue"
          fill="url(#colorGradient)"
          barSize={50}
          radius={[5, 5, 0, 0]}
          animationDuration={1000}
          animationEasing="ease-in-out"
          cursor="pointer"
          isAnimationActive={active === true ? true : false}
          animateNewValues={active === true ? true : false}
        >
          {/* <LabelList dataKey="revenue" position="top" formatter={formatShort} /> */}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ColumnsChart;
